import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import  Home from "../src/pages/home/home";
import Institucional from './pages/home/institucional';
import Blog from './pages/home/blog';
import Formulario from './pages/home/formulario';
import Noticia from "./pages/noticia1/noticia";
// import Noticia from "./pages/noticia2/noticia";
// import Noticia from "./pages/noticia3/noticia";
// import Noticia from "./pages/noticia4/noticia";
// import Noticia from "./pages/noticia5/noticia";
// import Noticia from "./pages/noticia6/noticia";
import Header from './components/Header/header';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />}> </Route>
        <Route path="/Institucional" element={<Institucional />}> </Route>
        <Route path="/Blog" element={<Blog />}> </Route> 
        <Route path="/Formulario" element={<Formulario />}></Route> 
        <Route path="/Noticia1" element={<Noticia />}></Route> 
        {/* <Route path="/Noticia2" element={<Noticia />}></Route> 
        <Route path="/Noticia3" element={<Noticia />}></Route> 
        <Route path="/Noticia4" element={<Noticia />}></Route> 
        <Route path="/Noticia5" element={<Noticia />}></Route> 
        <Route path="/Noticia6" element={<Noticia />}></Route>  */}
        <Route path="*" element={<Home />}> </Route>
      </Routes>
    </Router>
  );
}
 
export default App;